"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MediaStreamTypes;
(function (MediaStreamTypes) {
    MediaStreamTypes["MP4"] = "MP4";
    MediaStreamTypes["WEBM"] = "WEBM";
    MediaStreamTypes["HLS"] = "HLS";
    MediaStreamTypes["DASH"] = "DASH";
    MediaStreamTypes["OGG"] = "OGG";
    MediaStreamTypes["MOV"] = "MOV";
    MediaStreamTypes["MKV"] = "MKV";
})(MediaStreamTypes || (MediaStreamTypes = {}));
exports.MediaStreamTypes = MediaStreamTypes;
var MediaStreamDeliveryPriority;
(function (MediaStreamDeliveryPriority) {
    MediaStreamDeliveryPriority[MediaStreamDeliveryPriority["NATIVE_PROGRESSIVE"] = 0] = "NATIVE_PROGRESSIVE";
    MediaStreamDeliveryPriority[MediaStreamDeliveryPriority["ADAPTIVE_VIA_MSE"] = 1] = "ADAPTIVE_VIA_MSE";
    MediaStreamDeliveryPriority[MediaStreamDeliveryPriority["NATIVE_ADAPTIVE"] = 2] = "NATIVE_ADAPTIVE";
    MediaStreamDeliveryPriority[MediaStreamDeliveryPriority["FORCED"] = 3] = "FORCED";
})(MediaStreamDeliveryPriority || (MediaStreamDeliveryPriority = {}));
exports.MediaStreamDeliveryPriority = MediaStreamDeliveryPriority;
//# sourceMappingURL=media-stream.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/constants/media-stream.js
// module id = 49
// module chunks = 0